var Widget      = require("./Widget"),
    Button      = require("./Button"),
    DropDown    = require('./DropDown');


var ButtonGroup = Widget.extend({

    /**
     *
     * @param options
     */
    initialize: function(options){
        var that = this,
            _buttons,
            i;

        options || (options = {});
        that._view = undefined;

        that._buttons = [];

        options.orientation = options.orientation || 'vertical';

        if ('buttons' in options) {
            _buttons = options.buttons;
            delete options['buttons'];
        }

        ButtonGroup.__super__.initialize.call(that, options);

        that.getContainer().addClass(that.options['orientation'] + ' omjs-button-group');

        if (typeof options.css == 'object') {
            that._container.css(options.css);
        }

        for(i in _buttons) {
            that.add(_buttons[i]);
        }
    },

    /**
     *
     * @param view
     */
    onAdd: function(view){
        var that = this,
            i;
        that._view = view;
        for (i in that._buttons) {
            that._buttons[i].onAdd(that._view);
        }
    },

    /**
     *
     */
    add: function(button){
        var that = this;

        if (
            (button instanceof Button) || 
            (button instanceof DropDown)
        ) {
            that._buttons.push(button);
            that.getContainer()[0].appendChild(button.getContainer()[0]);
            if (that._view) {
                button.onAdd(that._view);
            }
        }

        return that;
    },

    /**
     *
     */
    remove: function(button){
        var that = this;

        if (~that._buttons.indexOf(button)) {
            that.getContainer()[0].removeChild(button.getContainer()[0]);
            if (that._view) {
                button.onRemove(that._view);
            }
            
            that._buttons.splice(that._buttons.indexOf(button), 1);
        }
        return that;
    }
});

module.exports = ButtonGroup;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/ButtonGroup.js
// module id = 200
// module chunks = 0